import React, { useState } from 'react';

export function CardShareButton({ cardId }: { cardId: string }) {
  const [status, setStatus] = useState<'idle' | 'copied' | 'manual'>('idle');
  const url = `https://www.overtureai.org/universe?card=${encodeURIComponent(cardId)}`;
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(url);
      setStatus('copied');
    } catch {
      setStatus('manual');
    }
  };
  return <div className="universe-share">
    <button type="button" className="universe-share-button" onClick={copy}>
      <svg viewBox="0 0 24 24" width="24" height="24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true"><circle cx="18" cy="5" r="3" /><circle cx="6" cy="12" r="3" /><circle cx="18" cy="19" r="3" /><path d="m8.6 10.5 6.8-4M8.6 13.5l6.8 4" /></svg>
      {status === 'copied' ? 'Link copied!' : 'Copy share link'}
    </button>
    <span role="status" className={status === 'copied' ? 'universe-share-status' : 'sr-only'}>{status === 'copied' ? 'Ready to paste into a message.' : ''}</span>
    {status === 'manual' && <label className="universe-share-fallback">Copy this link to share this creation:
      <input readOnly value={url} aria-label="Share link" autoFocus onFocus={event => event.currentTarget.select()} onClick={event => event.currentTarget.select()} />
    </label>}
  </div>;
}
